import {notification} from "@ui";
import "./CustomNotification.module.css";

const CustomNotification = {
  success: config => {
    // Handle both string and object parameters
    const messageConfig = typeof config === "string" ? {message: config} : config;

    notification.open({
      message: null,
      description: (
        <div
          style={{
            maxWidth: "695px",
            minHeight: "64px",
            borderRadius: "4px",
            padding: "29px 21px",
            gap: "21px",
            background: "var(--status-success-bg)",
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            boxSizing: "border-box",
            width: "100%",
          }}
        >
          <span
            style={{
              fontSize: "16px",
              color: "var(--theme-text-on-primary)",
              fontWeight: "500",
              wordWrap: "break-word",
              overflowWrap: "break-word",
              flex: "1",
              marginRight: messageConfig.action ? "10px" : "0",
            }}
          >
            {messageConfig.message}
          </span>
          {messageConfig.action && (
            <button
              type="button"
              onClick={messageConfig.action.onClick}
              style={{
                minWidth: "120px",
                height: "46px",
                borderRadius: "4px",
                padding: "12px 19px",
                gap: "10px",
                background: "var(--theme-surface-white)",
                border: "none",
                fontSize: "17px",
                color: "var(--theme-text-on-primary)",
                cursor: "pointer",
                fontWeight: "500",
                flexShrink: 0,
              }}
            >
              {messageConfig.action.text}
            </button>
          )}
        </div>
      ),
      placement: "topRight",
      duration: messageConfig.duration || 4,
      style: {
        maxWidth: "695px",
        width: "calc(100vw - 40px)",
        padding: 0,
        margin: 0,
      },
      className: "custom-notification-success",
    });
  },

  error: config => {
    // Handle both string and object parameters
    const messageConfig = typeof config === "string" ? {message: config} : config;

    notification.open({
      message: null,
      description: (
        <div
          style={{
            maxWidth: "695px",
            minHeight: "64px",
            borderRadius: "4px",
            padding: "29px 21px",
            gap: "21px",
            background: "var(--status-error-bg)",
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            boxSizing: "border-box",
            width: "100%",
          }}
        >
          <span
            style={{
              fontSize: "16px",
              color: "var(--theme-text-on-primary)",
              fontWeight: "500",
              wordWrap: "break-word",
              overflowWrap: "break-word",
              flex: "1",
              marginRight: messageConfig.action ? "10px" : "0",
            }}
          >
            {messageConfig.message}
          </span>
          {messageConfig.action && (
            <button
              type="button"
              onClick={config.action.onClick}
              style={{
                minWidth: "120px",
                height: "46px",
                borderRadius: "4px",
                padding: "12px 19px",
                gap: "10px",
                background: "var(--theme-surface-white)",
                border: "none",
                fontSize: "17px",
                color: "var(--theme-text-on-primary)",
                cursor: "pointer",
                fontWeight: "500",
                flexShrink: 0,
              }}
            >
              {messageConfig.action.text}
            </button>
          )}
        </div>
      ),
      placement: "topRight",
      duration: messageConfig.duration || 4,
      style: {
        maxWidth: "695px",
        width: "calc(100vw - 40px)",
        padding: 0,
        margin: 0,
      },
      className: "custom-notification-error",
    });
  },

  warning: config => {
    // Handle both string and object parameters
    const messageConfig = typeof config === "string" ? {message: config} : config;

    notification.open({
      message: null,
      description: (
        <div
          style={{
            maxWidth: "695px",
            minHeight: "64px",
            borderRadius: "4px",
            padding: "29px 21px",
            gap: "21px",
            background: "var(--status-warning-bg)",
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            boxSizing: "border-box",
            width: "100%",
          }}
        >
          <span
            style={{
              fontSize: "16px",
              color: "var(--theme-text-on-primary)",
              fontWeight: "500",
              wordWrap: "break-word",
              overflowWrap: "break-word",
              flex: "1",
            }}
          >
            {messageConfig.message}
          </span>
        </div>
      ),
      placement: "topRight",
      duration: messageConfig.duration || 4,
      style: {
        maxWidth: "695px",
        width: "calc(100vw - 40px)",
        padding: 0,
        margin: 0,
      },
      className: "custom-notification-warning",
    });
  },
};

export default CustomNotification;
